module.exports = __webpack_public_path__ + "img/map.0b9127f8.webp";